<template>
    <div class="d-flex align-items-start">
                        
        <!-- Rechts: Ausgewählte Tarife -->
        <div class="d-flex flex-column align-items-end flex-grow-1">
            <div v-for="tarif in ausgewaehlteTarife" :key="tarif.name">
                {{ tarif.name }}: <strong>{{ tarif.beitrag }}</strong> mtl.
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { getTarifName } from '@/helpers/hilfsfunktionen.js';

const props = defineProps({
    item: {
        type: Object,
        required: true
    }
})

// Ermittelt alle ausgewählten Tarife mit Namen und Beitrag
const ausgewaehlteTarife = computed(() => {
    const tarife = []
    
    if (props.item.tarif1 === 1) {
        tarife.push({ name: getTarifName(1), beitrag: props.item.tarif1beitragStr })
    }
    if (props.item.tarif2 === 1) {
        tarife.push({ name: getTarifName(2), beitrag: props.item.tarif2beitragStr })
    }
    if (props.item.tarif3 === 1) {
        tarife.push({ name: getTarifName(3), beitrag: props.item.tarif3beitragStr })
    }
    if (props.item.tarif4 === 1) {
        tarife.push({ name: getTarifName(4), beitrag: props.item.tarif4beitragStr })
    }
    if (props.item.tarif5 === 1) {
        tarife.push({ name: getTarifName(5), beitrag: props.item.tarif5beitragStr })
    }
    
    return tarife
})
</script>
